import React, { Fragment, useState } from 'react'
import { useDispatch } from 'react-redux';
import { handleSnackBar, invokePostService, setReRender } from '../../../store/global/actions';
import CustomizedDialogs from '../../atoms/dialog';
import { Button, CircularProgress, Typography } from '@material-ui/core';

export default function BlueprintDeleteDialog({isOpen=false, selectedItem, setActiveDialog}) {
    const dispatch = useDispatch()
    const [open, setOpen] = useState(isOpen);
	const [deleteLoader, setDeleteLoader] = useState(false);
	
    const toggleDeleteConfirmation = (event) => {
        if(open){
            setActiveDialog(null)
        }
        setOpen((prev) => !prev)
    };
	
    const onDelete = (event) => {	
		setDeleteLoader(true);
		dispatch(invokePostService('deleteBlueprint', { blueprintId: selectedItem._id, slug: selectedItem.slug })).then(res => {
			setDeleteLoader(false);
			if (res?.status == true) {
				dispatch(setReRender());
				dispatch(handleSnackBar({ open: true, message: "Blueprint is deleted!", severity: "success" }));
				toggleDeleteConfirmation();
			} else {
				dispatch(handleSnackBar({ open: true, message: res.message, severity: "error" }));
			}
		})
        setActiveDialog(null)
	};

  return (
    <CustomizedDialogs
		open={open}
		title="Delete"
		handleClose={toggleDeleteConfirmation}
		actions={
			<React.Fragment>
				<Button autoFocus onClick={toggleDeleteConfirmation} variant="outlined" color="primary" style={{textTransform: 'capitalize'}}>
					Close
				</Button>
				<Button autoFocus variant="contained" color="secondary" onClick={onDelete} disabled={deleteLoader} style={{textTransform: 'capitalize'}} endIcon={deleteLoader ? <CircularProgress color="secondary" size={20} /> : <Fragment />}>
					{deleteLoader ? 'Deleting..' : 'Delete'}
				</Button>
			</React.Fragment>
		}
	>
		<Typography>Are you sure you want to delete the selected blueprint?</Typography>
	</CustomizedDialogs>
  )
}
